import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableHead, TableRow, TableCell, Typography, Grid, Paper, TableBody, Fade, CircularProgress, Divider, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Icon } from '@material-ui/core';
import EnhancedTableToolbar from '../components/EnhancedTableToolbar';
import XLSX from 'xlsx';
import moment from 'moment';
import { WarehouseService } from '../Services/WarehouseService';
// import { format_fancy_notime } from '../Utils';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { format_fancy, HtmlTooltip } from '../Utils';

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        overflow: 'auto',
    },
    table: {
        height: 500,
        overflow: 'auto',
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(13),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    }
  })
);

function DailyInventoryReport(props) {

    const [lastSynced, setLastSynced] = useState(moment());
    const classes = useStyles();
    const [fetch, setFetch] = useState(false);
    const [data, setData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [rows, setRows] = useState([]);
    // const startdate = date.startOf('day').utc();
    // const enddate = date.endOf('day').utc();
    const [scheduleDate, setScheduleDate] = useState(moment());

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         fetchData();
    //     }, 60000);
    //     return () => clearInterval(interval);
    // }, []);

    useEffect(() => {
        props.setTitle('Daily Inventory Report');
    }, []);

    useEffect(() => {
        fetchData();
    }, [scheduleDate]);

    const fetchData = () => {
        setFetch(true);
        WarehouseService.getDailyInventoryReport(scheduleDate, moment(scheduleDate).startOf('day').utc(), moment(scheduleDate).endOf('day').utc())
        .then((data) => {
            console.log(data);
            setData(data.report);
            setHeaders(data.report_headers);
            setFetch(false);
            setLastSynced(moment());
        })
        .catch((error) => {
            setFetch(false);
        })
    }

    useEffect(() => {
        let rows = [];

        let agentMap = new Map();
        data.forEach((row) => {
            let a = {};
            if(agentMap.has(row.user_id)){
                a = agentMap.get(row.user_id);
            } else {
                a.user_id = row.user_id;
                a.name = row.name;
                a.issued_qty = 0;
                a.delivered_qty = 0;
                a.returned_qty = 0;
                a.total_remaining = 0;
                a.product_list = [];
                agentMap.set(a.user_id, a);
            }
            a.issued_qty += row.issued_qty;
            a.delivered_qty += row.delivered_qty > 0 ? row.delivered_qty : 0;
            a.returned_qty += row.returned_qty > 0 ? row.returned_qty : 0;
            a.total_remaining += row.total_remaining > 0 ? row.total_remaining : 0;
            a.product_list.push(row);
        });

        let index = 1;
        agentMap.forEach((value, key, map) => {
            let r = [];
            value.product_list.forEach((element, index) => {

                let others = headers.slice(4, -1).map((e, index) => 
                    <TableCell align="right" key={index + 100}>
                        <Typography variant="subtitle1" color="textPrimary">{element[e] ? element[e] : 0}</Typography>
                    </TableCell>
                );
    
                r.push(
                <TableRow key={index}>
                    <TableCell align="left">
                        <Typography variant="subtitle1" color="textPrimary">{index + 1}</Typography>
                    </TableCell>
                    <TableCell align="left">
                        <HtmlTooltip arrow title={element.product_display_name}>
                            <Typography variant="subtitle2" color="textPrimary">{element.product_name}</Typography>
                        </HtmlTooltip>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="subtitle1" color="textPrimary">{element.issued_qty}</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="subtitle1" color="textPrimary">{element.delivered_qty}</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="subtitle1" color="textPrimary">{element.returned_qty}</Typography>
                    </TableCell>
                    {others}
                    <TableCell align="right">
                        <Typography variant="subtitle1" color="textPrimary">{element.total_remaining}</Typography>
                    </TableCell>
                </TableRow>);
            });

            rows.push(<AgentDetails index={index++} key={key} agent={value} rows={r} headers={headers}/>);
        });

        setRows(rows);
    }, [data && headers]);

    function exportReport() {
        if(data && data.length > 0){
            let agents = new Set(data.map(s => s.name));
            if(agents.size > 0){
                const wb = XLSX.utils.book_new();

                agents.forEach((agent) => {
                    let sheetname = agent;
                    let exportData = [headers];
                    data.filter(f => f.name === agent).forEach((row) => {
                        let r = [row.product_name, row.issued_qty, row.delivered_qty, row.returned_qty];
                        
                        headers.slice(4, -1).forEach((e) => {
                            r.push(row[e] ? row[e] : 0);
                        });

                        r.push(row.total_remaining ? row.total_remaining : 0);

                        exportData.push(r);
                    });

                    const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                    XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                });
                
                XLSX.writeFile(wb, "Daily Inventory Report.xlsx");
            }
        } else {
            props.showSnackBar('Nothing to export', 'error');
        }
    }

    return (
        <div className="Home">
				<div style={{marginTop: 32}}>
                <div style={{float: "right"}}>
					<Typography variant="caption">
                        Last Refreshed: {lastSynced && lastSynced.format(format_fancy)}
                    </Typography>
                </div>
				<Grid container spacing={1} style={{marginTop: 20}}>
                    <Grid item lg={12} xs={12}>
                        <Paper className={classes.root}>
                            <Grid container>
                                <Grid item xs={12} lg={12}>
                                    <EnhancedTableToolbar 
                                        title={
                                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                                <DatePicker
                                                    variant="dialog"
                                                    margin="normal"
                                                    label="Date"
                                                    value={scheduleDate}
                                                    onChange={(date) => setScheduleDate(date)}
                                                    
                                                    format='DD MMM YYYY'
                                                    error={false}
                                                    maxDate={scheduleDate}
                                                    inputVariant="outlined"
                                                    invalidDateMessage=""
                                                    className={classes.formControl}
                                                />
                                            </MuiPickersUtilsProvider>} 
                                        exportReport={exportReport}
                                        refresh={fetchData}/>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    {!fetch && rows}
                                    <Fade
                                        in={fetch}
                                        style={{
                                            transitionDelay: fetch ? '10ms' : '0ms'
                                        }}
                                        unmountOnExit
                                        >
                                        <CircularProgress style={{marginTop: 20}}/>
                                    </Fade>
                                    {!fetch && <Divider />}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
				</Grid>
            </div>
        </div>
      );
};

function AgentDetails(props){

    const {agent, rows, headers} = props;
    
    const classes = useStyles();

    const [headerRows, setHeaderRows] = useState([]);

    let summary_rows = [];

    useEffect(() => {
        let h = [];
        h = headers.map((element, index) => 
            <TableCell align={index === 0 ? "left" : "right"} key={index}>
                <Typography variant="body2" color="textPrimary">{element}</Typography>
            </TableCell>
        );
        setHeaderRows(h);
    }, [headers])


    summary_rows.push(
            <Grid item key={1} xs={12} lg={2}>
                <Typography className={classes.subheading}>Issued Qty: {agent.issued_qty}</Typography>
            </Grid>
    );
    summary_rows.push(
        <Grid item key={2} xs={12} lg={2}>
            <Typography className={classes.subheading}>Delivered Qty: {agent.delivered_qty}</Typography>
        </Grid>
    );
    summary_rows.push(
        <Grid item key={3} xs={12} lg={2}>
            <Typography className={classes.subheading}>Returned Qty: {agent.returned_qty}</Typography>
        </Grid>
    );
    summary_rows.push(
        <Grid item key={4} xs={12} lg={2}>
            <Typography className={classes.subheading}>Remaining Qty: {agent.total_remaining}</Typography>
        </Grid>
    );
    
    return (
        <ExpansionPanel>
            <ExpansionPanelSummary
                expandIcon={<Icon>expand_more</Icon>}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{backgroundColor: '#DCEDC8'}}  
                >
                <Grid container justify="flex-start" alignItems="center" direction="row">
                    {/* <Grid item xs={12} lg={1}>
                        <Typography className={classes.heading}>{index}.</Typography>
                    </Grid> */}
                    <Grid item xs={12} lg={4}>
                        <Typography className={classes.heading} style={{textAlign: "left", paddingLeft: 5}}>{agent.name}</Typography>
                    </Grid>
                    {summary_rows}
                </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <Grid container spacing={0}>
                    <Grid item xs={12} lg={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <div style={{overflowX: 'auto', width: '100%'}}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">
                                        </TableCell>
                                        {headerRows}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows}
                                </TableBody>
                            </Table>
                        </div>
                    </Grid>
                </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}

export default DailyInventoryReport;